<template>
  <vn-bar
    :model="barChart.data"
    textField="label"
    valueField="value"
    :staggerLabels="barChart.staggerLabels"
    x-format=",.1f"
    y-format=",.2f"
  >
  </vn-bar>
</template>

<script>
export default {
  data() {
    var barChartData = [
      {
        key: "Cumulative Return",
        values: [
          { label: "Bawah 26", value: 10, color: "red" },
          { label: "26 - 40", value: 429, color: "#FFC107" },
          { label: "41 - 59", value: 867, color: "#66BB6A" },
          { label: "Atas 60", value: 406, color: "#29B6F6" },
          { label: "Tiada Maklumat", value: 0, color: "#7986CB" },
        ],
      },
    ];
    return {
      barChart: {
        data: barChartData,
        staggerLabels: false,
      },
    };
  },
};
</script>

<style>
.custom-bar-chart .nv-x text {
  transform: rotate(-45deg);
  text-anchor: end;
  transform-origin: 0 40px; /* Adjust the origin to move text away from the bars */
  dy: 1.5em; /* Add vertical space to move labels down */
}
</style>
